import type { MachineStatus, MachineType } from "@/features/machines/types";

export const MACHINE_TYPES: { value: MachineType; label: string }[] = [
  { value: "parter", label: "Parter" },
  { value: "cold_roll_mill", label: "Cold roll mill" },
  { value: "furnace", label: "Furnace" },
  { value: "skinpass_mill", label: "Skinpass mill" },
  { value: "slitter", label: "Slitter" },
  { value: "tube_mill", label: "Tube mill" },
  { value: "ctl", label: "CTL" },
  { value: "other", label: "Other" },
];

export const MACHINE_STATUSES: { value: MachineStatus; label: string }[] = [
  { value: "active", label: "Active" },
  { value: "under_maintenance", label: "Under maintenance" },
  { value: "inactive", label: "Inactive" },
];

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(status: MachineStatus): "success" | "warning" | "neutral" {
  if (status === "active") return "success";
  if (status === "under_maintenance") return "warning";
  return "neutral";
}
